import {useContext, useEffect} from 'react'
import {DataSourcesContext} from '../contexts'
import {DataSourceTemplates} from '../sources'
import {CatalogSelectionContext} from '../../catalog-selection'

export function useCatalogData() {
  const {mergedItems, mergedItemsStats, addSource, sourceConfigs} = useContext(DataSourcesContext)
  const {activeCatalogName} = useContext(CatalogSelectionContext)

  useEffect(() => {
    if (!activeCatalogName) return

    // Check if we already have a catalog source configured for the active catalog
    const hasCatalogSource = sourceConfigs.some(
      (config) => config.sourceID === 'catalog' && config.args?.catalogName === activeCatalogName
    )

    if (!hasCatalogSource) {
      addSource(DataSourceTemplates.catalog({catalogName: activeCatalogName}))
    }
  }, [activeCatalogName, sourceConfigs, addSource])

  return {
    catalogData: mergedItems,
    catalogStats: mergedItemsStats,
    isLoading: mergedItems.length === 0 && sourceConfigs.length > 0,
  }
}
